import React, { useState, useContext } from 'react';
import { useNavigate } from "react-router-dom";

const AppContext = React.createContext();

const AppProvider = ({ children }) => {
	const navigate = useNavigate();

	const [isSidebarOpen, setIsSidebarOpen] = useState(true);
	const [activeMenu, setActiveMenu] = useState("");
	const [cartCourseId, setCartCourseId] = useState([]);
	const [errorMessage, setErrorMessage] = useState();
	const [showErrorMessage, setShowErrorMessage] = useState();

	const handleNavClick = (key) => {
        setActiveMenu(key);
		navigate("/"+key);
    };

	const openSidebar = () => {
		setIsSidebarOpen(true);
	};

	const closeSidebar = () => {
		setIsSidebarOpen(false);
	};

	const handleCartAdd = (newCourseId) => {
		setCartCourseId((prevIds) =>
			prevIds.includes(newCourseId) ? prevIds : [...prevIds, newCourseId]
		);
	}
	
	return (
		<AppContext.Provider
			value={{ isSidebarOpen, openSidebar, closeSidebar, activeMenu, handleNavClick, setActiveMenu, cartCourseId, handleCartAdd, errorMessage, setErrorMessage, showErrorMessage, setShowErrorMessage }}
		>
			{children}
		</AppContext.Provider>
	);
};

export const useGlobalContext = () => {
	return useContext(AppContext);
};

export { AppContext, AppProvider };
